export default __webpack_public_path__ + "static/Graphik-Regular-Web-13ddf6a2c2748856d71f240291f360f2.woff2";